import { Redirect, Route, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { ROUTE_PREFIX_BOOKING } from '../../../constants/routes';
import { isAppointmentBooked } from '../../../utils/bookingUtils';
import { getLoadedWorkflow } from '../../../slices/workflow';

const BookingRouteWrapper = ({ children, ...rest }) => {
  const { workflowId } = useParams();
  const workflow = useSelector(({ workflow }) =>
    getLoadedWorkflow(workflow, workflowId)
  );

  // Without workflow data, or once an appointment is booked, go back to the
  // booking link's start, which loads the data or shows the booked appointment.
  if (isEmpty(workflow) || isAppointmentBooked(workflow)) {
    return <Redirect to={`${ROUTE_PREFIX_BOOKING}/${workflowId}`} />;
  }

  return <Route {...rest}>{children}</Route>;
};

export default BookingRouteWrapper;
